
import { Component, Vue } from 'vue-property-decorator';
import { useAuthStore } from '@/app/store/authModule';

@Component
export default class UserMenu extends Vue {
  get authStore() {
    return useAuthStore();
  }

  get user() {
    return this.authStore.loggedInIdentity;
  }

  get settingsBase() {
    if (this.authStore.isAgent) {
      return '/admin/settings';
    }
    return '/settings';
  }
}
